import { useEffect, useState } from "react";
import { getFinanceSummaryAPI } from "services/api/reports/finance/api";
import { FinanceSummary } from "services/api/reports/finance/types";
import { useDashboardDateRange } from "ui/modules/dashboard/pages/DashboardPage/context/DashboardDateRangeContext";
import RevenueExpenseCard from "ui/modules/dashboard/pages/DashboardPage/components/OverviewWidget/components/RevenueExpenseCard";
import { Loader } from "ui/components/Loader";
import KpiRow from "./components/KpiRow/KpiRow";
import PnlTable from "./components/PnlTable/PnlTable";

const FinancialSummaryTab: React.FC = () => {
  const { range } = useDashboardDateRange();
  const [data, setData] = useState<FinanceSummary | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    getFinanceSummaryAPI(range.from, range.to)
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setIsLoading(false));
  }, [range.from, range.to]);

  if (isLoading) {
    return (
      <div className="relative min-h-[200px]">
        <Loader isLoading={true}> </Loader>
      </div>
    );
  }

  if (!data) return <></>;

  return (
    <div className="px-0 pt-3 pb-6 xl:px-6 space-y-4">
      <KpiRow summary={data} />

      {/* Graf nosi kretanje kroz vrijeme, RDG stanje na kraju razdoblja — idu jedno uz drugo. */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-3">
        <div className="xl:col-span-2 bg-white rounded-sm border p-4 min-h-[360px] flex flex-col">
          <RevenueExpenseCard />
        </div>
        <PnlTable totals={data.totals} />
      </div>

      {data.estimatedPurchaseDateCount > 0 && (
        <div className="text-xs text-slate-400">
          Za {data.estimatedPurchaseDateCount} vozila korišten je datum unosa jer nema
          upisanog datuma kupovine.
        </div>
      )}
    </div>
  );
};

export default FinancialSummaryTab;
